﻿import { useEffect, useState } from 'react';
import isEqual from 'react-fast-compare';
import { createUserProfile, UserProfile } from '../models/profile';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { usePrevious } from '../../../../../../../shared/hooks/previousValue';
import { ProfileData } from '../ProfileApi';

export function useUserProfile(
    user: AuthenticatedUser,
    profileData: ProfileData | null,
    dependencies: any[]
): UserProfile {
    let initialUserProfile = createUserProfile({
        identityServerId: -1,
        username: null,
        name: user.details.name,
        firstName: user.details.firstname,
        lastName: user.details.lastname,
        email: null,
        phoneNumber: null,
        mobileNumber: null,
        languageKey: null,
        timeZoneId: null
    });

    let [userProfile, setUserProfile] = useState<UserProfile>(initialUserProfile);

    let previousUser = usePrevious<AuthenticatedUser>(user);
    useEffect(() => {
        if (user.details.isImpersonated && !isEqual(user, previousUser)) {
            let _userProfile = createUserProfile({
                identityServerId: -1,
                username: user.details.impersonatedUsername,
                name: user.details.name,
                firstName: user.details.firstname,
                lastName: user.details.lastname,
                email: null,
                phoneNumber: null,
                mobileNumber: null,
                languageKey: user.details.languageKey,
                timeZoneId: null
            });
            setUserProfile(_userProfile);
        } else if (profileData) {
            let { profile } = profileData;
            let _userProfile = createUserProfile({
                identityServerId: profile.identityServerId,
                username: profile.username,
                name: profile.name,
                firstName: profile.firstname,
                lastName: profile.lastname,
                email: profile.email,
                phoneNumber: profile.phoneNumber,
                mobileNumber: profile.mobile,
                languageKey: profile.language,
                timeZoneId: profile.timeZoneId
            });
            setUserProfile(_userProfile);
        }
    }, [user, ...dependencies]);

    return userProfile;
}
